import { z } from "zod";
const attributesFineprintSchema = z.object(
  {}
);
export {
  attributesFineprintSchema
};
//# sourceMappingURL=attributes.js.map
